import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

export const StyledToastContainer = styled(ToastContainer)`
  && {
    .Toastify__toast {
      align-items: flex-start;
      min-height: fit-content;
      padding: 1rem;
      ${({ theme }) => theme.typography.p3};
      background: ${({ theme }) => theme.palette.background.paper};
      color: ${({ theme }) => theme.palette.text.secondary};
      border: 1px solid ${({ theme }) => theme.palette.divider};
      box-shadow: ${({ theme }) => theme.shadow.menu};
      border-radius: ${({ theme }) => theme.shape.tooltipRadius};

      button {
        svg {
          color: ${({ theme }) => theme.palette.text.primary};
        }
      }
    }

    .Toastify__toast-icon {
      svg:not(.MuiCircularProgress-svg) {
        width: 1.5rem;
        height: 1.5rem;
      }

      svg.MuiCircularProgress-svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }

    .Toastify__progress-bar--info {
      background: ${({ theme }) => theme.palette.status.blue.text};
    }

    .Toastify__progress-bar--success {
      background: ${({ theme }) => theme.palette.status.green.text};
    }

    .Toastify__progress-bar--error {
      background: ${({ theme }) => theme.palette.status.red.text};
    }

    .Toastify__progress-bar--warn {
      background: ${({ theme }) => theme.palette.status.yellow.text};
    }
  }
`;
